import { finalize } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { GeneralService } from './../../services/general.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
  selector: 'shc-terms',
  templateUrl: './terms.page.html',
  styleUrls: ['./terms.page.scss'],
})
export class TermsPage implements OnInit {
  terms: string;

  constructor(
    private generalService: GeneralService,
    private errorService: ErrorHandlerService
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.getPageContent();
  }

  getPageContent() {
    this.generalService.showLoader();
    this.generalService.getPageContent({ type: 'terms' }).pipe(
      finalize(() => this.generalService.hideLoader())
    ).subscribe(res => {
      this.terms = res.content;
    }, error => {
      this.errorService.handle(error);
    });
  }

}
